// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gyzjzbnglzfheqgqyowy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd5emp6Ym5nbHpmaGVxZ3F5b3d5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDcyNDEzMTgsImV4cCI6MjA2MjgxNzMxOH0.AGLDCFbMRpm3-zsdGOAC93ovrZ2rS98mUx21w6DQee8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);